import { useQuery } from '@tanstack/react-query';
import { fetchAvailableTimes } from 'flux/clients/experiences';

interface LocalsAvailableForDateTimeProps {
  experienceId: string;
  date: string;
  time: string;
  hostId?: string;
}

function getRandomIds(idsArray, count = 3) {
  const shuffled = idsArray.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

function useLocalsAvailableForDateTime({
  experienceId,
  date,
  time,
  hostId,
}: LocalsAvailableForDateTimeProps) {
  const { isLoading, data } = useQuery(
    ['localsAvailableForDateTime', experienceId, date],
    () => fetchAvailableTimes({ experienceId, date }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: !!experienceId && !!date,
      cacheTime: 5000,
      retry: 0,
    },
  );

  const availableHosts =
    (data &&
      Object.keys(data).filter((id) => {
        return (
          (hostId && id !== hostId && data[id].includes(time)) ||
          (!hostId && data[id].includes(time))
        );
      })) ||
    [];

  const randomAvailableHosts = getRandomIds(availableHosts);

  return {
    isLoading,
    availableHosts: randomAvailableHosts || [],
  };
}

export default useLocalsAvailableForDateTime;
